import { useMantineTheme } from '@mantine/core';
import type { Ref } from 'react';
import { Icon } from '@/components';
import { WorkLogStatusIconMap } from '@/features/types';
import classes from './WorklogIcon.module.css';
import { WorkLogStatus } from '@/generated/types/navigator/types.gen';

interface Props {
  workStatus: WorkLogStatus;
  ref?: Ref<HTMLDivElement>;
}

export const WorklogIcon = ({ workStatus, ref }: Props) => {
  const theme = useMantineTheme();
  const icon = workStatus && WorkLogStatusIconMap.get(workStatus);

  return (
    <div
      ref={ref}
      className={classes.workStatusIcon}
      style={{
        width: '24px',
        height: '24px',

        backgroundColor:
          workStatus === WorkLogStatus.WORK_NEEDED
            ? theme.other.workActivityColor.badBackground
            : theme.other.workActivityColor.goodBackground,
      }}
    >
      {icon && <Icon size={18} name={icon} />}
    </div>
  );
};
